import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { initializeVdrClient } from 'scaleflow/utils/aws-clients/s3VDRClient';
import type StoreService from 'scaleflow/services/store';

export default class DataFileFileNameController extends Controller {
  @service declare store: StoreService;
  @tracked progress = 0;
  @tracked downloading = false;

  @action
  async handleDownloadRequest(fileName: string) {
    const client = await initializeVdrClient(this.store);
    const downloader = client.downloadFileWithProgress(fileName);
    this.downloading = true;
    let downloadedBlob = null;

    for await (const { blob, progress } of downloader) {
      this.progress = progress;
      if (blob) downloadedBlob = blob;
    }

    /**
     * Alternate way to handle the async generator, for funsies
     */
    // while(!downloadedBlob){
    //   const {value} = await downloader.next();
    //   console.log("Progress:", value);
    //   this.progress = value.progress;
    //   if(value.blob) downloadedBlob = value.blob;
    // }

    const fileUrl = URL.createObjectURL(downloadedBlob as Blob);
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download =
      (this.model as Record<string, string>)['file_name']?.split('/')?.pop() ||
      'download';
    document.body.appendChild(link);

    // Trigger the download
    link.click();
    document.body.removeChild(link);

    this.downloading = false;
    this.progress = 0;
  }

  get fileName() {
    return (this.model as Record<string, string>)['file_name'];
  }

  get formattedFileName() {
    return (
      (this.model as Record<string, string>)['file_name']?.split('/')?.pop() ??
      'Download'
    );
  }
}
